import React, {ReactElement} from "react";
import {PageFragment} from "@/shared/PageFragment";
import {StyledBoxColumn} from "@/shared/StyledComponents";
import {DIVIDER, PD_XLG, PD_XLG2} from "@/shared/dimens";
import {Typography} from "@mui/material";
import {UserDisplayName} from "@/shared/types";

export class DashboardFragment extends PageFragment {

  protected getTitle(): string | null | undefined {
    return "Dashboard";
  }

  renderContent(): ReactElement {
    return <>
      <StyledBoxColumn
        style={{
          padding: `${PD_XLG2}px ${PD_XLG}px`,
          background: this.theme.palette.background.paper,
          borderBottom: DIVIDER
        }}>
        <Typography variant={"h4"}>Hello, {UserDisplayName(this.getMemberAuth().member.user)}</Typography>
        <Typography>Welcome to Elements.</Typography>
      </StyledBoxColumn>
      <StyledBoxColumn style={{padding: PD_XLG, gap: PD_XLG}}>
        <StyledBoxColumn>
          <Typography variant={"h5"}>Elements</Typography>
        </StyledBoxColumn>
      </StyledBoxColumn>
    </>;
  }
}